var _rect, _path, _rect2, _rect3, _path2, _path3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudInfrastructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 2,
    x: 39,
    y: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48,29h1V27H15v2h1a3,3,0,0,1,0,6H15v6H49V35H48a3,3,0,0,1,0-6ZM27,36a2,2,0,0,1-2,2H23a2,2,0,0,1-2-2V32a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2Zm8,0a2,2,0,0,1-2,2H31a2,2,0,0,1-2-2V32a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2Zm8,0a2,2,0,0,1-2,2H39a2,2,0,0,1-2-2V32a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 2,
    x: 31,
    y: 32
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 2,
    x: 23,
    y: 32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62,57H35.858A4,4,0,0,0,33,54.142V42H31V54.142A4,4,0,0,0,28.142,57H2v2H28.142a3.981,3.981,0,0,0,7.716,0H62ZM32,60a2,2,0,1,1,2-2A2,2,0,0,1,32,60Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9,31h5a1,1,0,0,1-1-1V26a1,1,0,0,1,1-1H50a1,1,0,0,1,1,1v4a1,1,0,0,1-1,1,10,10,0,0,0,0-20h-.61a1,1,0,0,1-.943-.667,9.486,9.486,0,0,0-17.573-.794,1,1,0,0,1-1.619.285A9.5,9.5,0,0,0,13,16.5V20a1,1,0,0,1-1,1H9A5,5,0,0,0,9,31Zm47-7H54V22h2ZM50,14a6.006,6.006,0,0,1,6,6H54a4,4,0,0,0-4-4Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 2,
    x: 15,
    y: 42
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 2,
    x: 19,
    y: 42
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 2,
    x: 23,
    y: 42
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 2,
    x: 27,
    y: 42
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 2,
    x: 35,
    y: 42
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 2,
    x: 39,
    y: 42
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 2,
    x: 43,
    y: 42
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 2,
    x: 47,
    y: 42
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudInfrastructure);
export default __webpack_public_path__ + "static/media/cloud-infrastructure.d4da7d19ad60e3868d50c1624941f89a.svg";
export { ForwardRef as ReactComponent };